import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "empty"]

  add(event) {
    event.preventDefault()
    if (!this.hasTemplateTarget || !this.hasListTarget) return

    const row = this.templateTarget.content.firstElementChild.cloneNode(true)
    const index = this.listTarget.querySelectorAll("[data-qualification-questions-row]").length
    row.querySelectorAll("[name]").forEach((input) => {
      input.name = input.name.replace("__INDEX__", String(index))
      input.id = input.id?.replace("__INDEX__", String(index))
    })
    row.querySelectorAll("[for]").forEach((label) => {
      label.htmlFor = label.htmlFor.replace("__INDEX__", String(index))
    })

    this.listTarget.appendChild(row)
    this.syncEmpty()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-qualification-questions-row]")
    row?.remove()
    this.syncEmpty()
  }

  syncEmpty() {
    if (!this.hasEmptyTarget || !this.hasListTarget) return
    const hasRows = this.listTarget.querySelectorAll("[data-qualification-questions-row]").length > 0
    this.emptyTarget.hidden = hasRows
  }
}
